// extracted by mini-css-extract-plugin
export default {"label":"email_label__eK2TE","input":"email_input__qx6Lr"};